import React from 'react'
import { toast } from 'react-toastify'
import CloseIcon from '@mui/icons-material/Close'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Typography
} from '@mui/material'
import CustomerLogApi from 'api/faber/CustomerLogAPI'
import { AxiosError } from 'axios'
import PropTypes from 'prop-types'

function DeleteSmartDelayDialog( {flightID, faberToken} ) {
  const [isDialogOpen, setDialogOpen] = React.useState(false)

  const handleConfirmDelete = async () => {
    setDialogOpen(false)
    try{
      const deleteSmartDelayRes = await CustomerLogApi.deleteSmartDelayForms(flightID, faberToken)
      if (deleteSmartDelayRes && deleteSmartDelayRes.data.status == "SUCCESS"){
        toast.success('Flight Registration has been deleted. Auto-refreshing in a few seconds...', {
          autoClose: 3000,
          hideProgressBar: false
        })
        setTimeout(() => {
          window.location.reload()
        }, 3000)
      } else {
        toast.error(
          "There was an issue deleting the Flight Registration. Please try again later."
        )
      }
    } catch (e: unknown) {
      if (e instanceof AxiosError){
        toast.error(
          `${e.code}. \nThere was an issue deleting the Flight Registration. Please try again later`
        )
      }
    }
  }

  return (
    <>
      <Button onClick={() => setDialogOpen(true)}>
        Delete
      </Button>
      <Dialog
        open={isDialogOpen}
        onClose={() => setDialogOpen(false)}
        maxWidth='sm'
        fullWidth
      >
        <DialogTitle variant='h4' id='alert-dialog-title'>
          Request Delete Smart Delay Record
        </DialogTitle>
        <IconButton
          aria-label='close'
          onClick={() => setDialogOpen(false)}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (_theme) => _theme.palette.grey[500]
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          <DialogContentText id='alert-dialog-description'>
            <Typography variant='subtitle1' sx={{ marginBottom: '24px' }}>
              Do you want to delete this record?
              <br /> <br />
              This permanently deletes the Smart Delay Record.
            </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
        <Button
            variant='filled'
            onClick={() => setDialogOpen(false)}
            data-cy='proceedDelBtn'
          >
            Cancel
          </Button>
          <Button
            variant='filled'
            onClick={() => handleConfirmDelete()}
            data-cy='proceedDelBtn'
          >
            Proceed to Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
DeleteSmartDelayDialog.propTypes = {
  flightID: PropTypes.string,
  faberToken: PropTypes.string
}

export default DeleteSmartDelayDialog
